import styled from 'styled-components'
import CommonStyles from 'shared/style/commonPageStyles'

const Style = {
	Wrapper: CommonStyles.PageWrapper,

	PreviewImg: styled.img`
		width: 240px;
		height: 120px;
		object-fit: cover;
		object-position: center center;
		border-radius: 8px;
		margin: 8px 0;
	`,
	Radio: styled.button`
		display: flex;
		align-items: center;
		gap: 8px;
	`,
}

export default Style
